/* eslint-disable no-restricted-imports */
import React, { useEffect, useState, useCallback } from "react";
import {
  InputLabel,
  Button,
  RadioGroup,
  Radio,
  Checkbox,
  FormControlLabel
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Toast, Col, Row } from "react-bootstrap";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { v4 as uuidv4 } from "uuid";
import {
  modifyZimbraConfig,
  getAllZimbraConfig
} from "../modules/Auth/_redux/adminCrud";

export function SecurityPage() {
  const useStyles = makeStyles(theme => ({
    inputStyle: {
      display: "inline-flex",
      width: "200px",
      height: "32px",
      border: "1px solid #c8cace",
      paddingLeft: "8px",
      borderRadius: "2px 2px 2px 2px",
      ":active": {
        border: "1px solid #c8cace"
      }
    },
    buttonStyle: {
      width: "120px",
      height: "32px",
      color: "#123456",
      border: "1px solid #123456",
      fontSize: "1.2rem",
      marginRight: "12px"
    },
    buttonSmallStyle: {
      width: "60px",
      height: "28px",
      color: "#123456",
      border: "1px solid #123456",
      fontSize: "1rem"
      //   marginLeft: "12px"
    },

    buttonDisableStyle: {
      color: "#b4b5b8",
      border: "1px solid #b4b5b8",
      background: "#ebedf1"
    },
    buttonClearStyle: {
      width: "32px",
      height: "32px",
      border: "0px solid #123456",
      marginRight: "12px",
      "&:hover": {
        backgroundColor: "transparent !important"
      }
    },
    searchStyle: {
      width: "120px",
      height: "32px",
      color: "#123456",
      border: "1px solid #123456",
      fontSize: "1rem",
      float: "right"
    },
    dateStyle: {
      width: "160px",
      height: "32px",
      color: "#123456",
      border: "1px solid #c8cace",
      fontSize: "1rem",
      marginRight: "36px",
      textAlign: "left",
      background: "transparent",
      borderRadius: "4px 4px 4px 4px",
      paddingLeft: "12px"
    },

    boxContainer: {
      display: "inline-block",
      width: "100%",
      verticalAlign: "top"
    },
    box30Style: {
      width: "100%",
      display: "inline-block",
      background: "white",
      border: "1px solid lightgray",
      padding: "24px",
      marginBottom: "12px"
    },
    boxStyle: {
      width: "100%",
      display: "inline-block",
      background: "white",
      border: "1px solid lightgray",
      padding: "24px",
      marginBottom: "12px"
    },
    subTitleStyle: {
      display: "block",
      fontSize: "1.2rem",
      width: "100%",
      marginBottom: "12px",
      fontWeight: "bold",
      alignItems: "baseline",
      color: "#555555"
    },

    halfWidthStyle: {
      display: "inline-block",
      fontSize: "1.2rem",
      width: "40%",
      overflow: "overlay",
      marginBottom: "12px",
      marginRight: "10%",
      verticalAlign: "top",
      fontWeight: "bold",
      alignItems: "baseline",
      color: "#555555"
    },
    scrollStyle: {
      display: "inline-block",
      width: "100%",
      height: "300px",
      maxHeight: "200px",
      overflow: "overlay"
    },
    subTitleLastStyle: {
      fontSize: "1rem",
      //   fontWeight: "bold",
      color: "#555555",
      marginTop: "-8px"
    },
    labelStyle: {
      display: "inline-block",
      // width: "200px",
      marginTop: "-2px",
      fontSize: "1.2rem"
    },

    headerRowStyle: {
      display: "flex",
      textAlign: "center",
      width: "100%",
      height: "44px",
      marginTop: "12px",
      lineHeight: "44px"
    },
    headerColStyle: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "center",
      width: "100%",
      background: "#dfe2e8",
      height: "44px"
    },
    headerCol100Style: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "center",
      width: "100%",
      background: "#dfe2e8",
      height: "44px"
    },
    headerCheckboxStyle: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "center",
      width: "44px",
      background: "#dfe2e8",
      height: "44px"
    },
    dataCheckboxStyle: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "center",
      width: "44px",
      //   background: "#dfe2e8",
      height: "44px"
    },
    dataRowStyle: {
      display: "flex",
      textAlign: "center",
      // width: "40%",
      height: "44px",
      lineHeight: "44px",
      borderBottom: "1px solid lightgray"
    },
    width100Style: {
      width: "100%"
    },
    dataColStyle: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "left",
      width: "100%",
      height: "44px"
    },
    dataCol100Style: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "center",
      width: "100%",
      height: "44px"
    },
    dataColSmallStyle: {
      display: "inline-block",
      fontSize: "12px",
      textAlign: "center",
      width: "50%",
      height: "44px",
      overflow: "hidden",
      lineHeight: "16px",
      paddingTop: "6px"
    },
    dataColTextStyle: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "left",
      //   width: "50%",
      height: "44px"
    },
    radioStyle: {
      width: "80px",
      fontSize: "1rem",
      //   background: "transparent",
      color: "#555555",
      borderColor: "#dfe2e8",
      //   paddingTop: "6px",
      //   "&:hover": {
      //     color: "#123456",
      //     backgroundColor: "#eae4f5 !important"
      //   },
      "&:active": {
        color: "white",
        backgroundColor: "#123456 !important"
      }
    },
    selected: {
      color: "white",
      backgroundColor: "#123456 !important"
    }
  }));

  const regexIp = new RegExp(
    "^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]).){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$"
  );
  const regexDomain = new RegExp(
    // "^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]).)*([A-Za-z0-9]|[A-Za-z0-9][A-Za-z0-9-]*[A-Za-z0-9])$"
    "^(([a-zA-Z]|[a-zA-Z][a-zA-Z0-9-]*[a-zA-Z0-9]).)*([A-Za-z]|[A-Za-z][A-Za-z0-9-]*[A-Za-z0-9])$"
  );
  const Styles = useStyles();

  const [refresh, setRefresh] = React.useState(false);
  const [useBack, setUseBack] = React.useState("FALSE");
  const [showAsk, setShowAsk] = React.useState(false);
  const [showNew, setShowNew] = React.useState(false);
  const [showToast, setShowToast] = React.useState(false);
  const [editTitle, setEditTitle] = React.useState("");
  const [editIP, setEditIP] = React.useState("");
  const [editType, setEditType] = React.useState(1);
  const [editDesc, setEditDesc] = React.useState("");

  const [allCheckedRblClient, setAllCheckedRblClient] = React.useState(false);
  const [allCheckedRhsblClient, setAllCheckedRhsblClient] = React.useState(
    false
  );
  const [allCheckedRhsblReverse, setAllCheckedRhsblReverse] = React.useState(
    false
  );
  const [allCheckedRhsblSender, setAllCheckedRhsblSender] = React.useState(
    false
  );

  const [
    reject_invalid_helo_hostname,
    set_reject_invalid_helo_hostname
  ] = React.useState(false);
  const [
    reject_non_fqdn_helo_hostname,
    set_reject_non_fqdn_helo_hostname
  ] = React.useState(false);
  const [reject_non_fqdn_sender, set_reject_non_fqdn_sender] = React.useState(
    false
  );
  const [
    reject_unknown_client_hostname,
    set_reject_unknown_client_hostname
  ] = React.useState(false);
  const [
    reject_unknown_helo_hostname,
    set_reject_unknown_helo_hostname
  ] = React.useState(false);
  const [
    reject_unknown_reverse_client_hostname,
    set_reject_unknown_reverse_client_hostname
  ] = React.useState(false);
  const [
    reject_unknown_sender_domain,
    set_reject_unknown_sender_domain
  ] = React.useState(false);

  const [reject_rbl_client, set_reject_rbl_client] = React.useState([]);
  const [reject_rhsbl_client, set_reject_rhsbl_client] = React.useState([]);
  const [
    reject_rhsbl_reverse_client,
    set_reject_rhsbl_reverse_client
  ] = React.useState([]);
  const [reject_rhsbl_sender, set_reject_rhsbl_sender] = React.useState([]);

  const checkIpAddress = () => {
    return regexIp.test(editIP) || regexDomain.test(editIP);
  };
  const handleChangeUse = event => {
    setUseBack(event.target.value);
  };

  const handlePressDelete = type => {
    // setShowAsk(true);

    if (type === 1)
      set_reject_rbl_client(reject_rbl_client.filter(m => !m.checked));
    if (type === 2)
      set_reject_rhsbl_client(reject_rhsbl_client.filter(m => !m.checked));
    if (type === 3)
      set_reject_rhsbl_reverse_client(
        reject_rhsbl_reverse_client.filter(m => !m.checked)
      );
    if (type === 4)
      set_reject_rhsbl_sender(reject_rhsbl_sender.filter(m => !m.checked));
  };

  const handlePressNew = type => {
    if (type === 1) setEditTitle("RBL 클라이언트 추가");
    if (type === 2) setEditTitle("RHSBL 클라이언트 추가");
    if (type === 3) setEditTitle("RHSBL 리버스 클라이언트 추가");
    if (type === 4) setEditTitle("RHSBL 발신자 추가");

    setEditType(type);
    setEditIP("");
    setEditDesc("");
    setShowNew(true);
  };

  const handlePressSave = () => {
    if (!checkIpAddress()) return;

    console.log(editType, editIP);

    if (editType === 1) {
      reject_rbl_client.unshift({
        domain: editIP,
        checked: false
      });
      set_reject_rbl_client(reject_rbl_client);
    }

    if (editType === 2) {
      reject_rhsbl_client.unshift({
        domain: editIP,
        checked: false
      });
      set_reject_rhsbl_client(reject_rhsbl_client);
    }

    if (editType === 3) {
      reject_rhsbl_reverse_client.unshift({
        domain: editIP,
        checked: false
      });
      set_reject_rhsbl_reverse_client(reject_rhsbl_reverse_client);
    }

    if (editType === 4) {
      reject_rhsbl_sender.unshift({
        domain: editIP,
        checked: false
      });
      set_reject_rhsbl_sender(reject_rhsbl_sender);
    }

    setRefresh(!refresh);
    setShowNew(false);
  };

  const handlePressSaveAll = () => {
    const attrs = [];
    const xxx = {
      reject_invalid_helo_hostname,
      reject_non_fqdn_helo_hostname,
      reject_non_fqdn_sender,
      reject_unknown_client_hostname,
      reject_unknown_helo_hostname,
      reject_unknown_reverse_client_hostname,
      reject_unknown_sender_domain,

      reject_rbl_client,
      reject_rhsbl_client,
      reject_rhsbl_reverse_client,
      reject_rhsbl_sender
    };

    if (reject_invalid_helo_hostname) {
      attrs.push({
        name: "zimbraMtaRestriction",
        value: "reject_invalid_helo_hostname"
      });
    }

    if (reject_non_fqdn_helo_hostname) {
      attrs.push({
        name: "zimbraMtaRestriction",
        value: "reject_non_fqdn_helo_hostname"
      });
    }
    if (reject_non_fqdn_sender) {
      attrs.push({
        name: "zimbraMtaRestriction",
        value: "reject_non_fqdn_sender"
      });
    }

    if (reject_unknown_client_hostname) {
      attrs.push({
        name: "zimbraMtaRestriction",
        value: "reject_unknown_client_hostname"
      });
    }
    if (reject_unknown_helo_hostname) {
      attrs.push({
        name: "zimbraMtaRestriction",
        value: "reject_unknown_helo_hostname"
      });
    }
    if (reject_unknown_reverse_client_hostname) {
      attrs.push({
        name: "zimbraMtaRestriction",
        value: "reject_unknown_reverse_client_hostname"
      });
    }
    if (reject_unknown_sender_domain) {
      attrs.push({
        name: "zimbraMtaRestriction",
        value: "reject_unknown_sender_domain"
      });
    }

    reject_rbl_client.forEach(item => {
      attrs.push({
        name: "zimbraMtaRestriction",
        value: "reject_rbl_client " + item.domain
      });
    });

    reject_rhsbl_client.forEach(item => {
      attrs.push({
        name: "zimbraMtaRestriction",
        value: "reject_rhsbl_client " + item.domain
      });
    });

    reject_rhsbl_reverse_client.forEach(item => {
      attrs.push({
        name: "zimbraMtaRestriction",
        value: "reject_rhsbl_reverse_client " + item.domain
      });
    });

    reject_rhsbl_sender.forEach(item => {
      attrs.push({
        name: "zimbraMtaRestriction",
        value: "reject_rhsbl_sender " + item.domain
      });
    });

    console.log("handlePressSaveAll", attrs);

    modifyZimbraConfig(attrs).then(result => {
      console.log("modifyZimbraConfig", result);
    })
    .catch(error => {
      console.log(error)
    })
  };

  const initConfig = () => {
    getAllZimbraConfig().then(result => {
      console.log("getAllZimbraConfig", result);

      const data = result.data.allConfig.filter(
        a => a.n === "zimbraMtaRestriction"
      );

      /*
      zimbraMtaRestriction reject_invalid_helo_hostname
      zimbraMtaRestriction reject_non_fqdn_sender 
      zimbraMtaRestriction "reject_rbl_client zen.spamhaus.org"
      zimbraMtaRestriction "reject_rbl_client psbl.surriel.com"
      zimbraMtaRestriction "reject_rbl_client b.barracudacentral.org"
      zimbraMtaRestriction "reject_rhsbl_client dbl.spamhaus.org"
      zimbraMtaRestriction "reject_rhsbl_client multi.uribl.com"
      zimbraMtaRestriction "reject_rhsbl_client multi.surbl.org"
      zimbraMtaRestriction "reject_rhsbl_reverse_client dbl.spamhaus.org"
      zimbraMtaRestriction "reject_rhsbl_sender multi.uribl.com"
      zimbraMtaRestriction "reject_rhsbl_sender multi.surbl.org"
      zimbraMtaRestriction "reject_rhsbl_sender rhsbl.sorbs.net"
      zimbraMtaRestriction "reject_rhsbl_sender dbl.spamhaus.org" */

      /*
      0: "reject_invalid_helo_hostname"
      1: "reject_non_fqdn_helo_hostname"
      2: "reject_non_fqdn_sender"
      3: "reject_unknown_client_hostname"
      4: "reject_unknown_helo_hostname"
      5: "reject_unknown_reverse_client_hostname"
      6: "reject_unknown_sender_domain"
      7: "reject_rbl_client xxxx.com"
      8: "reject_rbl_client bbbb.io"
      9: "reject_rhsbl_client cccc.com"
      10: "reject_rhsbl_client dddd.io"
      11: "reject_rhsbl_reverse_client qqqqq.com"
      12: "reject_rhsbl_reverse_client wwwwwww.com"
      13: "reject_rhsbl_sender ssssss.com"
      14: "reject_rhsbl_sender fffffff.io"
      */

      const reject_rbl_client = [];
      const reject_rhsbl_client = [];
      const reject_rhsbl_reverse_client = [];
      const reject_rhsbl_sender = [];

      data.forEach(ext => {
        if (ext._content.indexOf("reject_invalid_helo_hostname") >= 0)
          set_reject_invalid_helo_hostname(true);
        if (ext._content.indexOf("reject_non_fqdn_helo_hostname") >= 0)
          set_reject_non_fqdn_helo_hostname(true);
        if (ext._content.indexOf("reject_non_fqdn_sender") >= 0)
          set_reject_non_fqdn_sender(true);
        if (ext._content.indexOf("reject_unknown_client_hostname") >= 0)
          set_reject_unknown_client_hostname(true);
        if (ext._content.indexOf("reject_unknown_helo_hostname") >= 0)
          set_reject_unknown_helo_hostname(true);
        if (ext._content.indexOf("reject_unknown_reverse_client_hostname") >= 0)
          set_reject_unknown_reverse_client_hostname(true);
        if (ext._content.indexOf("reject_unknown_sender_domain") >= 0)
          set_reject_unknown_sender_domain(true);

        if (ext._content.indexOf("reject_rbl_client") >= 0) {
          const target = ext._content.split(" ")[1];
          reject_rbl_client.push({
            domain: target,
            checked: false
          });
        }
        if (ext._content.indexOf("reject_rhsbl_client") >= 0) {
          const target = ext._content.split(" ")[1];
          reject_rhsbl_client.push({
            domain: target,
            checked: false
          });
        }
        if (ext._content.indexOf("reject_rhsbl_reverse_client") >= 0) {
          const target = ext._content.split(" ")[1];
          reject_rhsbl_reverse_client.push({
            domain: target,
            checked: false
          });
        }
        if (ext._content.indexOf("reject_rhsbl_sender") >= 0) {
          const target = ext._content.split(" ")[1];
          reject_rhsbl_sender.push({
            domain: target,
            checked: false
          });
        }
      });

      set_reject_rbl_client(reject_rbl_client);
      set_reject_rhsbl_client(reject_rhsbl_client);
      set_reject_rhsbl_reverse_client(reject_rhsbl_reverse_client);
      set_reject_rhsbl_sender(reject_rhsbl_sender);

      console.log(
        "zimbraMtaRestriction",
        Object.assign(data.map(ext => ext._content))
      );

      // setExtensions();
    })
    .catch(error => {
      console.log(error)
    })
  };

  useEffect(() => {}, [
    editTitle,
    editIP,
    editDesc,
    showToast,
    refresh,
    reject_invalid_helo_hostname,
    reject_non_fqdn_helo_hostname,
    reject_non_fqdn_sender,
    reject_unknown_client_hostname,
    reject_unknown_helo_hostname,
    reject_unknown_reverse_client_hostname,
    reject_unknown_sender_domain
  ]);

  useEffect(() => {
    initConfig();
  }, []);

  return (
    <>
      <div
        style={{
          marginTop: "12px",
          marginLeft: "-12px",
          height: "100%"
        }}
      >
        {/* -------------------- */}

        <div className={Styles.boxContainer}>
          <div className={Styles.boxStyle}>
            <div className={Styles.subTitleStyle}>
              <Button
                className={Styles.buttonStyle}
                onClick={() => {
                  handlePressSaveAll();
                }}
              >
                저장
              </Button>
            </div>

            {/* <div className={Styles.subTitleLastStyle}>
              <div
                style={{
                  display: "inline-block",
                  marginTop: "-2px",
                  fontSize: "1.2rem"
                }}
              >
                메일백업 / PC에 저장
              </div>
              <RadioGroup
                aria-label="방향"
                name="gender1"
                style={{
                  display: "inline-block",
                  marginLeft: "24px",
                  fontSize: "1.2rem"
                }}
                // className={classes4.group}
                value={useBack}
                onChange={handleChangeUse}
              >
                <FormControlLabel
                  value="TRUE"
                  style={{ marginTop: "4px", fontSize: "1.2rem" }}
                  control={<Radio />}
                  label="사용함"
                />
                <FormControlLabel
                  value="FALSE"
                  style={{ marginTop: "4px", fontSize: "1.2rem" }}
                  control={<Radio />}
                  label="사용안함"
                />
              </RadioGroup>
            </div> */}
            <div className={Styles.subTitleStyle}>프로토콜 보안</div>

            <div className={Styles.subTitleLastStyle}>
              <FormControlLabel
                style={{ marginLeft: "unset" }}
                control={
                  <Checkbox
                    checked={reject_invalid_helo_hostname}
                    onChange={e => {
                      set_reject_invalid_helo_hostname(
                        !reject_invalid_helo_hostname
                      );
                    }}
                    inputProps={{
                      "aria-label": "primary checkbox"
                    }}
                  />
                }
              />
              <div className={Styles.labelStyle}>
                HELO 정보가 RFC 규약을 지키지 않으면 차단
                {/* Host name in greeting violates RFC
                (reject_invalid_helo_hostname) */}
              </div>
            </div>

            <div className={Styles.subTitleLastStyle}>
              <FormControlLabel
                style={{ marginLeft: "unset" }}
                control={
                  <Checkbox
                    checked={reject_non_fqdn_helo_hostname}
                    onChange={e => {
                      set_reject_non_fqdn_helo_hostname(
                        !reject_non_fqdn_helo_hostname
                      );
                    }}
                    inputProps={{
                      "aria-label": "primary checkbox"
                    }}
                  />
                }
              />
              <div className={Styles.labelStyle}>
                클라이언트 HELO 정보의 호스트 이름이 FQDN 형식을 준수하지 않으면
                차단
                {/* Client must greet with FQDN hostname
                (reject_non_fqdn_helo_hostname) */}
              </div>
            </div>

            <div className={Styles.subTitleLastStyle}>
              <FormControlLabel
                style={{ marginLeft: "unset" }}
                control={
                  <Checkbox
                    checked={reject_non_fqdn_sender}
                    onChange={e => {
                      set_reject_non_fqdn_sender(!reject_non_fqdn_sender);
                    }}
                    inputProps={{
                      "aria-label": "primary checkbox"
                    }}
                  />
                }
              />
              <div className={Styles.labelStyle}>
                발신자 주소가 FQDN 형식을 준수하지 않으면 차단
                {/* Sender address must be FQDN hostname (reject_non_fqdn_sender) */}
              </div>
            </div>

            {/* ----------------------- */}

            <div className={Styles.subTitleStyle}>DNS 보안</div>

            <div className={Styles.subTitleLastStyle}>
              <FormControlLabel
                style={{ marginLeft: "unset" }}
                control={
                  <Checkbox
                    checked={reject_unknown_client_hostname}
                    onChange={e => {
                      set_reject_unknown_client_hostname(
                        !reject_unknown_client_hostname
                      );
                    }}
                    inputProps={{
                      "aria-label": "primary checkbox"
                    }}
                  />
                }
              />
              <div className={Styles.labelStyle}>
                발신자 IP 주소가 Reverse DNS 로 조회되지 않으면 차단
                {/* Client IP Address (reject_unknown_client_hostname) */}
              </div>
            </div>

            <div className={Styles.subTitleLastStyle}>
              <FormControlLabel
                style={{ marginLeft: "unset" }}
                control={
                  <Checkbox
                    checked={reject_unknown_reverse_client_hostname}
                    onChange={e => {
                      set_reject_unknown_reverse_client_hostname(
                        !reject_unknown_reverse_client_hostname
                      );
                    }}
                    inputProps={{
                      "aria-label": "primary checkbox"
                    }}
                  />
                }
              />
              <div className={Styles.labelStyle}>
                Greeting 시 호스트 이름이 포함되지 않으면 차단
                {/* Hostname in greeting (reject_unknown_reverse_client_hostname) */}
              </div>
            </div>

            <div className={Styles.subTitleLastStyle}>
              <FormControlLabel
                style={{ marginLeft: "unset" }}
                control={
                  <Checkbox
                    checked={reject_unknown_sender_domain}
                    onChange={e => {
                      set_reject_unknown_sender_domain(
                        !reject_unknown_sender_domain
                      );
                    }}
                    inputProps={{
                      "aria-label": "primary checkbox"
                    }}
                  />
                }
              />
              <div className={Styles.labelStyle}>
                발신자 주소의 도메인이 DNS 조회 가능하지 않으면 차단
                {/* Sender's domain (reject_unknown_sender_domain) */}
              </div>
            </div>

            <div className={Styles.subTitleLastStyle}>
              <FormControlLabel
                style={{ marginLeft: "unset" }}
                control={
                  <Checkbox
                    checked={reject_unknown_helo_hostname}
                    onChange={e => {
                      set_reject_unknown_helo_hostname(
                        !reject_unknown_helo_hostname
                      );
                    }}
                    inputProps={{
                      "aria-label": "primary checkbox"
                    }}
                  />
                }
              />
              <div className={Styles.labelStyle}>
                HELO 교환시 DNS 조회 가능한 호스트 이름이 아니면 차단
                {/* Client must greet with resolving host name
                (reject_unknown_helo_hostname) */}
              </div>
            </div>

            <div className={Styles.halfWidthStyle}>
              <div>
                RBL 클라이언트 목록
                <div style={{ display: "inline-flex", float: "right" }}>
                  <Button
                    className={Styles.buttonSmallStyle}
                    onClick={() => handlePressNew(1)}
                  >
                    추가
                  </Button>
                  &nbsp;&nbsp;
                  <Button
                    className={Styles.buttonSmallStyle}
                    onClick={() => {
                      handlePressDelete(1);
                      setShowToast(true);
                    }}
                  >
                    삭제
                  </Button>
                </div>
              </div>

              <div className={Styles.scrollStyle}>
                <div className={Styles.headerRowStyle}>
                  <div className={Styles.headerCheckboxStyle}>
                    <FormControlLabel
                      style={{ marginLeft: "unset" }}
                      control={
                        <Checkbox
                          checked={allCheckedRblClient}
                          onChange={e => {
                            setAllCheckedRblClient(!allCheckedRblClient);
                            reject_rbl_client.map(
                              item => (item.checked = !allCheckedRblClient)
                            );
                            setRefresh(!refresh);
                          }}
                          value="true"
                          inputProps={{
                            "aria-label": "primary checkbox"
                          }}
                        />
                      }
                    />
                  </div>
                  <div className={Styles.headerColStyle}>
                    도메인 혹은 IP 주소
                  </div>
                </div>
                {reject_rbl_client.map(item => (
                  <div className={Styles.dataRowStyle} key={uuidv4()}>
                    <div className={Styles.dataCheckboxStyle}>
                      <FormControlLabel
                        style={{ marginLeft: "unset" }}
                        control={
                          <Checkbox
                            checked={item.checked}
                            onChange={e => {
                              item.checked = !item.checked;
                              setRefresh(!refresh);
                            }}
                            value="true"
                            inputProps={{
                              "aria-label": "primary checkbox"
                            }}
                          />
                        }
                      />
                    </div>
                    <div className={Styles.dataColStyle}>{item.domain}</div>
                  </div>
                ))}
              </div>
            </div>

            <div className={Styles.halfWidthStyle}>
              <div>
                RHSBL 클라이언트 목록
                <div style={{ display: "inline-flex", float: "right" }}>
                  <Button
                    className={Styles.buttonSmallStyle}
                    onClick={() => handlePressNew(2)}
                  >
                    추가
                  </Button>
                  &nbsp;&nbsp;
                  <Button
                    className={Styles.buttonSmallStyle}
                    onClick={() => {
                      handlePressDelete(2);
                      setShowToast(true);
                    }}
                  >
                    삭제
                  </Button>
                </div>
              </div>

              <div className={Styles.scrollStyle}>
                <div className={Styles.headerRowStyle}>
                  <div className={Styles.headerCheckboxStyle}>
                    <FormControlLabel
                      style={{ marginLeft: "unset" }}
                      control={
                        <Checkbox
                          checked={allCheckedRhsblClient}
                          onChange={e => {
                            setAllCheckedRhsblClient(!allCheckedRhsblClient);
                            reject_rhsbl_client.map(
                              item => (item.checked = !allCheckedRhsblClient)
                            );
                            setRefresh(!refresh);
                          }}
                          inputProps={{
                            "aria-label": "primary checkbox"
                          }}
                        />
                      }
                    />
                  </div>
                  <div className={Styles.headerColStyle}>
                    도메인 혹은 IP 주소
                  </div>
                </div>

                {reject_rhsbl_client.map(item => (
                  <div className={Styles.dataRowStyle} key={uuidv4()}>
                    <div className={Styles.dataCheckboxStyle}>
                      <FormControlLabel
                        style={{ marginLeft: "unset" }}
                        control={
                          <Checkbox
                            checked={item.checked}
                            onChange={e => {
                              item.checked = !item.checked;
                              setRefresh(!refresh);
                            }}
                            value="true"
                            inputProps={{
                              "aria-label": "primary checkbox"
                            }}
                          />
                        }
                      />
                    </div>
                    <div className={Styles.dataColStyle}>{item.domain}</div>
                  </div>
                ))}
              </div>
            </div>

            <div className={Styles.halfWidthStyle}>
              <div>
                RHSBL 리버스 클라이언트 목록
                <div style={{ display: "inline-flex", float: "right" }}>
                  <Button
                    className={Styles.buttonSmallStyle}
                    onClick={() => handlePressNew(3)}
                  >
                    추가
                  </Button>
                  &nbsp;&nbsp;
                  <Button
                    className={Styles.buttonSmallStyle}
                    onClick={() => {
                      handlePressDelete(3);
                      setShowToast(true);
                    }}
                  >
                    삭제
                  </Button>
                </div>
              </div>

              <div className={Styles.scrollStyle}>
                <div className={Styles.headerRowStyle}>
                  <div className={Styles.headerCheckboxStyle}>
                    <FormControlLabel
                      style={{ marginLeft: "unset" }}
                      control={
                        <Checkbox
                          checked={allCheckedRhsblReverse}
                          onChange={e => {
                            setAllCheckedRhsblReverse(!allCheckedRhsblReverse);
                            reject_rhsbl_reverse_client.map(
                              item => (item.checked = !allCheckedRhsblReverse)
                            );
                            setRefresh(!refresh);
                          }}
                          inputProps={{
                            "aria-label": "primary checkbox"
                          }}
                        />
                      }
                    />
                  </div>
                  <div className={Styles.headerColStyle}>
                    도메인 혹은 IP 주소
                  </div>
                </div>
                {reject_rhsbl_reverse_client.map(item => (
                  <div className={Styles.dataRowStyle} key={uuidv4()}>
                    <div className={Styles.dataCheckboxStyle}>
                      <FormControlLabel
                        style={{ marginLeft: "unset" }}
                        control={
                          <Checkbox
                            checked={item.checked}
                            onChange={e => {
                              item.checked = !item.checked;
                              setRefresh(!refresh);
                            }}
                            value="true"
                            inputProps={{
                              "aria-label": "primary checkbox"
                            }}
                          />
                        }
                      />
                    </div>
                    <div className={Styles.dataColStyle}>{item.domain}</div>
                  </div>
                ))}
              </div>
            </div>

            <div className={Styles.halfWidthStyle}>
              <div>
                RHSBL 발신자 목록
                <div style={{ display: "inline-flex", float: "right" }}>
                  <Button
                    className={Styles.buttonSmallStyle}
                    onClick={() => handlePressNew(4)}
                  >
                    추가
                  </Button>
                  &nbsp;&nbsp;
                  <Button
                    className={Styles.buttonSmallStyle}
                    onClick={() => {
                      handlePressDelete(4);
                      setShowToast(true);
                    }}
                  >
                    삭제
                  </Button>
                </div>
              </div>

              <div className={Styles.scrollStyle}>
                <div className={Styles.headerRowStyle}>
                  <div className={Styles.headerCheckboxStyle}>
                    <FormControlLabel
                      style={{ marginLeft: "unset" }}
                      control={
                        <Checkbox
                          checked={allCheckedRhsblSender}
                          onChange={e => {
                            setAllCheckedRhsblSender(!allCheckedRhsblSender);
                            reject_rhsbl_sender.map(
                              item => (item.checked = !allCheckedRhsblSender)
                            );
                            setRefresh(!refresh);
                          }}
                          inputProps={{
                            "aria-label": "primary checkbox"
                          }}
                        />
                      }
                    />
                  </div>
                  <div className={Styles.headerColStyle}>
                    도메인 혹은 IP 주소
                  </div>
                </div>

                {reject_rhsbl_sender.map(item => (
                  <div className={Styles.dataRowStyle} key={uuidv4()}>
                    <div className={Styles.dataCheckboxStyle}>
                      <FormControlLabel
                        style={{ marginLeft: "unset" }}
                        control={
                          <Checkbox
                            checked={item.checked}
                            onChange={e => {
                              item.checked = !item.checked;
                              setRefresh(!refresh);
                            }}
                            value="true"
                            inputProps={{
                              "aria-label": "primary checkbox"
                            }}
                          />
                        }
                      />
                    </div>
                    <div className={Styles.dataColStyle}>{item.domain}</div>
                  </div>
                ))}
              </div>
            </div>

            <div style={{ height: "24px" }}></div>

            {/* <div className={Styles.subTitleStyle}>
              수신차단 IP
              <div style={{ display: "inline-flex", float: "right" }}>
                <Button
                  className={Styles.buttonSmallStyle}
                  onClick={() => handlePressNew(false)}
                >
                  추가
                </Button>
                &nbsp;&nbsp;
                <Button
                  className={Styles.buttonSmallStyle}
                  onClick={() => {
                    handlePressDelete();
                  }}
                >
                  삭제
                </Button>
              </div>
            </div>

            <div className={Styles.headerRowStyle}>
              <div className={Styles.headerCheckboxStyle}>
                <FormControlLabel
                  style={{ marginLeft: "unset" }}
                  control={
                    <Checkbox
                      // checked={autoLogin}
                      onChange={e => {}}
                      value="true"
                      inputProps={{
                        "aria-label": "primary checkbox"
                      }}
                    />
                  }
                />
              </div>
              <div className={Styles.headerColStyle}>IP</div>
              <div className={Styles.headerColStyle}>날짜</div>
              <div className={Styles.headerColStyle}>등록자</div>
              <div className={Styles.headerCol100Style}>비고</div>
              <div className={Styles.headerColStyle}>수정</div>
            </div>

            {blackList.map(item => (
              <div className={Styles.dataRowStyle} key={uuidv4()}>
                <div className={Styles.dataCheckboxStyle}>
                  <FormControlLabel
                    style={{ marginLeft: "unset" }}
                    control={
                      <Checkbox
                        // checked={autoLogin}
                        onChange={e => {}}
                        value="true"
                        inputProps={{
                          "aria-label": "primary checkbox"
                        }}
                      />
                    }
                  />
                </div>
                <div className={Styles.dataColStyle}>{item.ipAddr}</div>
                <div className={Styles.dataColStyle}>{item.date}</div>
                <div className={Styles.dataColStyle}>{item.author}</div>
                <div className={Styles.dataCol100Style}>{item.desc}</div>
                <div className={Styles.dataColStyle}>
                  <Button
                    className={Styles.buttonSmallStyle}
                    onClick={() => {
                      handlePressModify(false, item);
                    }}
                  >
                    수정
                  </Button>
                </div>
              </div>
            ))} */}
          </div>
        </div>
      </div>

      <Dialog
        open={showAsk}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"삭제"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            선택한 항목을 삭제하시겠습니까?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            color="primary"
            onClick={() => {
              setShowAsk(false);
              setShowToast(true);
            }}
          >
            아니오
          </Button>
          <Button
            color="primary"
            autoFocus
            onClick={() => {
              setShowAsk(false);
            }}
          >
            예
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={showNew}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{editTitle}</DialogTitle>
        <DialogContent>
          <div>
            <input
              type="text"
              placeholder="도메인 혹은 IP 주소"
              value={editIP}
              className={Styles.inputStyle}
              onChange={e => {
                console.log("IP", e.target.value);
                setEditIP(e.target.value);
              }}
            ></input>
          </div>
        </DialogContent>
        <DialogActions>
          <div
            style={{
              width: "100%",
              textAlign: "center",
              paddingTop: "16px",
              paddingBottom: "8px"
            }}
          >
            <Button
              className={Styles.buttonSmallStyle}
              onClick={() => {
                setShowNew(false);
              }}
            >
              취소
            </Button>
            <Button
              className={[
                Styles.buttonSmallStyle
                // !checkIpAddress() && Styles.buttonDisableStyle
              ]}
              style={{
                marginLeft: "24px",
                background: `${!checkIpAddress() ? "#d5cce8" : "unset"}`
              }}
              autoFocus
              onClick={() => {
                handlePressSave();
              }}
            >
              저장
            </Button>
          </div>
        </DialogActions>
      </Dialog>
    </>
  );
}
